import { useContext, createContext } from "react"
import { AccessService } from "../auth/api/accessService"

const AccessContext = createContext<AccessService | undefined>(undefined)

interface AccessProviderProps {
  accessService: AccessService
  children: React.ReactNode
}

export const AccessProvider = ({ children, accessService }: AccessProviderProps) => (
  <AccessContext.Provider value={accessService}>{children}</AccessContext.Provider>
)

export function useAccess() {
  const context = useContext(AccessContext)

  if (context === undefined) {
    throw new Error(`useAccess must be used inside AccessProvider.`)
  }

  return context
}
